import React from 'react'
import { Link } from 'react-router-dom'
import Layout from '../component/Layout/Layout'


function MadeForHer() {
    return (
        <Layout title="Made For Her : Chaashni by Maansi & Ketan" description="Chaashni by Maansi & Ketan: Description" > 
        <div className="site-content-wrap static-page home-full hometext-wrap new-design made-for-her">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">                        
                        <div className="hometext-tab">
                            <h2><em>She</em> doesn’t have to figure it all out <em>herself</em>.</h2>
                            <p><em>Chaashni</em> is here to understand, guide and help <em>her</em> find what feels truly right — whether that means choosing from our collection, changing something <em>she</em> loves, or creating it around <em>her</em> requirements.</p>
                            <p>The goal is to help <em>her</em> look extraordinary and feel entirely <em>herself</em>.</p>
                            <p>Made for <em>Her , Her</em> Way.</p>
                            <div className='clickme-button'><Link to='/shop-by-collection'>LET’S DISCOVER WHAT’S RIGHT FOR ME →</Link></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </Layout>
    )
}

export default MadeForHer
